/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import { SkinningUserDetails, SkinningUserList } from './components';
import { SelectedSkinningUserProvider } from './context';

export const SkinningUsers = () => {
  return (
    <SelectedSkinningUserProvider>
      <Routes>
        <Route path="/" element={<SkinningUserList />} />
        <Route path="/:userId" element={<SkinningUserDetails />} />
      </Routes>
    </SelectedSkinningUserProvider>
  );
};
